export const CONNECTOR_JSON_PROPERTIES = [
    "lockMovementX",
    "lockMovementY",
    "selectable",
    "evented",
    "customType",
    "objectId",
    "actionText",
    "isPlaceholder",
    "stickyMinHeight",
    "stickyPadding",
    "stickyFormat",
    "connectorFromId",
    "connectorToId",
    "connectorStyle",
    "connectorParentId",
];

export const isWhiteboardConnector = (object) => ["connector", "connector_head"].includes(object?.customType);

export const isLinkableWhiteboardObject = (object) => Boolean(
    object
    && !isWhiteboardConnector(object)
    && object.selectable !== false
    && object.evented !== false
);

/**
 * Écarte uniquement les connecteurs incomplets (par exemple une sauvegarde
 * interrompue entre la ligne et sa flèche). Les autres objets restent intacts.
 * Ainsi un canevas historique ne peut plus faire tomber l'interface entière.
 */
export const sanitiseWhiteboardCanvasPayload = (canvasData) => {
    let payload = canvasData;

    if (typeof payload === "string") {
        try {
            payload = JSON.parse(payload);
        } catch (error) {
            return {version: "5.4.2", objects: []};
        }
    }

    const objects = Array.isArray(payload?.objects) ? payload.objects : [];
    const linkableIds = new Set(objects
        .filter(object => !isWhiteboardConnector(object) && object?.objectId)
        .map(object => object.objectId));

    const validConnectors = objects.filter(object => object?.customType === "connector"
        && object?.objectId
        && object.connectorFromId !== object.connectorToId
        && linkableIds.has(object.connectorFromId)
        && linkableIds.has(object.connectorToId));
    const connectorIds = new Set(validConnectors.map(object => object.objectId));

    return {
        ...(payload && typeof payload === "object" ? payload : {}),
        objects: objects.filter(object => {
            if (object?.customType === "connector") {
                return connectorIds.has(object.objectId);
            }
            if (object?.customType === "connector_head") {
                return connectorIds.has(object.connectorParentId);
            }
            return true;
        }),
    };
};

export const createWhiteboardLink = ({fabric, source, target, style, createId}) => {
    if (!isLinkableWhiteboardObject(source) || !isLinkableWhiteboardObject(target) || source === target) {
        throw new Error("Deux objets distincts et disponibles sont requis pour créer une liaison.");
    }

    const from = source.getCenterPoint();
    const to = target.getCenterPoint();
    const isArrow = style === "arrow";
    const connector = new fabric.Line([from.x, from.y, to.x, to.y], {
        stroke: "#007EBA",
        strokeWidth: 3,
        strokeLineCap: "round",
        strokeDashArray: style === "dashed" ? [9, 7] : null,
        customType: "connector",
        connectorFromId: source.objectId,
        connectorToId: target.objectId,
        connectorStyle: style,
        objectId: createId("connector"),
    });

    const head = isArrow ? new fabric.Triangle({
        left: to.x,
        top: to.y,
        width: 16,
        height: 20,
        fill: "#007EBA",
        originX: "center",
        originY: "center",
        angle: (Math.atan2(to.y - from.y, to.x - from.x) * 180 / Math.PI) + 90,
        customType: "connector_head",
        connectorParentId: connector.objectId,
        connectorFromId: source.objectId,
        connectorToId: target.objectId,
        objectId: createId("connector-head"),
    }) : null;

    return {connector, head};
};
